import { useAppDispatch, useAppSelector } from '../../../../../lib/store';
import { selectSelectedNoteId } from '../../../state/selector';
import { setSelectedNoteId } from '../../../state/supervisorSlice';

export interface UseNoteListItemResult {
  selectNote: (value: string) => void;
  selectedNoteId: string | null;
}

export const useNoteListItem = (): UseNoteListItemResult => {
  const dispatch = useAppDispatch();
  const selectedNoteId = useAppSelector(selectSelectedNoteId);

  const selectNote = (value: string) => {
    dispatch(setSelectedNoteId(value));
  };
  return { selectNote, selectedNoteId };
};
